let AfterLoginLayout = () => import('../components/AfterLoginLayout.vue');
let AfterLoginHome = () => import('../pages/after_login/Home.vue');

export default [
    {
        path: '/after-login',
        component: AfterLoginLayout,
        meta: { requiresAuth: true, hideShopLayout: true },
        children: [
            {
                path: '',
                component: AfterLoginHome,
                name: 'AfterLogin',
                meta: { requiresAuth: true, hideShopLayout: true },
            },
        ],
    },
];
